import {useContext} from "react";
import {StateContext} from "../Contexts";
import {defaultSepaPaymentData} from "../Billwerk/PaymentData";
import Disturber from "./Disturber";

export default function (props) {
    /** @type CheckoutState */
    const state = useContext(StateContext);

    function removeJwtCookie() {
        // get the current first and second level domain
        const domainParts = window.location.hostname.split('.');
        const domain = domainParts.slice(-2).join('.');

        document.cookie = 'erecht24_login_jwt=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.' + domain + '; Secure';

        // remove user related data from session storage, cookies and context
        sessionStorage?.setItem('checkout_payment_data', JSON.stringify(defaultSepaPaymentData));
        sessionStorage?.setItem('checkout_payment_option', null);

        const newCustomerData = state.customerData;
        newCustomerData.EmailAddress = '';
        sessionStorage?.setItem('checkout_customer_data', JSON.stringify(newCustomerData));

        let baseUrl = document.querySelector('[data-checkout]').dataset.env === 'production'
            ? 'https://login.e-recht24.de/'
            : 'https://login.e-recht24.dev/';

        window.location.href = baseUrl + 'logout?redirect=' + window.location.href;
    }

    return (
        <Disturber>
            <p>
                <b>Ihre Bestellung wird Ihrem aktuellen Kundenkonto zugeordnet.</b><br/>
                Falls Sie ein neues Kundenkonto anlegen möchten, müssen Sie sich zunächst <a
                className={'font-bold text-blue hover:text-gray-very-dark hover:underline hover:cursor-pointer'}
                onClick={removeJwtCookie}>abmelden</a>.
            </p>
        </Disturber>
    )
}
